export default {
  competitions_title: {
    en: 'Our competitions',
    fr: 'Nos compétitions',
  },
  next_competition_title: {
    en: 'Our next competition',
    fr: 'Notre prochaine compétition',
  },
  notable_tasks_title: {
    en: 'Notable tasks',
    fr: 'Tâches notables',
  },
  next_competition_content: {
    en: 'Our next competition will be held at the Thun military base in Switzerland. We will be competing against teams from around the world to demonstrate the capabilities of our robots in a real-world emergency scenario.',
    fr: "Notre prochaine compétition se tiendra à la base militaire de Thoune en Swisse. Nous affronterons des équipes du monde entier pour démontrer les capacités de nos robots dans un scénario d'urgence réel.",
  },
  european_robotics_rights: {
    fr: '© Ces images sont la propriété de l’European Robotics et peuvent être trouvées sur',
    en: '© These images are the property of the European Robotics and can be found on',
  },
  task_mapping_nuclear_power_plant: {
    en: 'Create a 3D map of the nuclear power plant',
    fr: 'Créer une carte 3D de la centrale nucléaire',
  },
  task_mapping_photorealistic: {
    en: 'Create a photorealistic map of the environment',
    fr: 'Créer une carte photoréaliste de l’environnement',
  },
  task_nuclear_source: {
    en: 'Locate and identify radioactive sources',
    fr: 'Localiser et identifier les sources radioactives',
  },
  task_rescue_hazardous: {
    en: 'Rescue a dummy from a hazardous area',
    fr: "Secourir un mannequin d'une zone dangereuse",
  },
  task_fast_navigation: {
    en: 'Navigate through obstacle courses as fast as possible',
    fr: "Naviguer à travers des parcours d'obstacles le plus rapidement possible",
  },
  task_autonomous_navigation: {
    en: 'Navigate autonomously and avoid obstacles while carrying a payload',
    fr: 'Naviguer de manière autonome et éviter les obstacles tout en transportant une charge',
  },
  task_qr_scan: {
    en: 'Scan QR codes to collect information',
    fr: 'Scanner des codes QR pour collecter des informations',
  },
  task_object_manipulation: {
    en: 'Use our robotic arm to pick up objects and place them in designated areas',
    fr: 'Utiliser notre bras robotique pour ramasser des objets et les placer dans des zones désignées',
  },
  task_thermal_detection: {
    en: 'Use a thermal camera to detect heat sources',
    fr: 'Utiliser une caméra thermique pour détecter les sources de chaleur',
  },
  task_co2_detection: {
    en: 'Detect CO2 levels in the environment',
    fr: "Détecter les niveaux de CO2 dans l'environnement",
  },
  task_hazardous_sign_detection: {
    en: 'Identify hazardous signs with our camera system',
    fr: 'Identifier les signes dangereux avec notre système de caméra',
  },
  elrob_difficulties: {
    en: 'The Elrob competition is known for its challenging tasks that test the limits of robotic capabilities. Teams must navigate complex environments, and perform precise operations under time constraints. The scenarios often simulate real-world situations where robots must operate in hazardous conditions or perform tasks that require high levels of autonomy and reliability.',
    fr: "La compétition Elrob est connue pour ses tâches difficiles qui testent les limites des capacités robotiques. Les équipes doivent naviguer dans des environnements complexes, et effectuer des opérations précises sous contrainte de temps. Les scénarios simulent souvent des situations réelles où les robots doivent opérer dans des conditions dangereuses ou effectuer des tâches nécessitant un haut niveau d'autonomie et de fiabilité.",
  },
  task_elrob_mapping_description: {
    fr: 'Créer une carte photoréaliste de l’environnement en utilisant des techniques avancées de cartographie et de modélisation 3D. Annotation des points d’intérêt et des obstacles pour une navigation efficace. Tracer l’itinéraire suivi par le robot pendant le processus de cartographie.',
    en: 'Create a photorealistic map of the environment using advanced mapping and 3D modeling techniques. Annotate points of interest and obstacles for effective navigation. Plot the route that the robot followed during the mapping process.',
  },
  task_elrob_mule_description: {
    fr: 'Naviguer de manière autonome à travers un chemin appris et éviter les obstacles tout en transportant une charge. Utiliser des capteurs pour détecter et éviter les obstacles, et ajuster la trajectoire en conséquence. Assurer une adaptation dynamique de la trajectoire pour éviter les obstacles.',
    en: 'Navigate autonomously through a teached-in path and avoid obstacles while carrying a payload. Use sensors to detect and avoid obstacles, and adjust the trajectory accordingly. Ensure dynamic adaptation of the trajectory to avoid obstacles.',
  },
  task_elrob_rescue_hazardous_description: {
    fr: 'Secourir un mannequin d’une zone dangereuse en utilisant la mobilité et la manipulation du robot. Identifier les obstacles et les dangers potentiels dans la zone de sauvetage. Assurer la sécurité du mannequin pendant le transport.',
    en: 'Rescue a dummy from a hazardous area using the robot’s mobility and manipulation capabilities. Identify obstacles and potential hazards in the rescue area. Ensure the safety of the dummy during transport.',
  },
};
